import { render } from "./cashComponent.vue?vue&type=template&id=20952b74"
import script from "./cashComponent.vue?vue&type=script&lang=js"
export * from "./cashComponent.vue?vue&type=script&lang=js"

import "./cashComponent.vue?vue&type=style&index=0&id=20952b74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__